/**
 * @generated SignedSource<<5fc58972dd2f07fe74e24a5316dce318>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RightContentFragment$data = {
  readonly viewer: {
    readonly user?: {
      readonly id: string;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"LoggedInNavFragment">;
  readonly " $fragmentType": "RightContentFragment";
};
export type RightContentFragment$key = {
  readonly " $data"?: RightContentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"RightContentFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RightContentFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LoggedInNavFragment"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GalleryUser",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "Viewer",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "921d6ddd9061997cc5adbc008a915ebd";

export default node;
